export const columns = [
    {
        field: "id",
        headerName: "ID",
        width: 90,
    },
    {
        field: "name",
        headerName: "الاسم",
        width: 150,
    },
    {
        field: "status",
        headerName: "الحالة",
        width: 150,
    },
    {
        field: "subscription_plan",
        headerName: "الخطة",
        width: 150,
    },
    {
        field: "created_at",
        headerName: "تاريخ الاضافة",
        width: 150,
    },
    {
        field: "updated_at",
        headerName: "تاريخ التحديث",
        width: 150,
    },
];